import { useBoundingRect } from './useBoundingRect';
import { useEffect, useState } from 'react';

type IsOutOfBoundType = {
  top?: boolean;
  left?: boolean;
  bottom?: boolean;
  right?: boolean;
  any?: boolean;
  all?: boolean;
};

/*!
 * Check if an element is out of the viewport
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}  elem The element to check
 * @return {Object}     A set of booleans for each side of the element
 */
export const useIsOutOfBound = (isElementInDom: boolean) => {
  const [isOutOfBound, setIsOutOfBound] = useState<IsOutOfBoundType>();
  const { boundingRect, ref } = useBoundingRect(isElementInDom);

  // Check if it's out of the viewport on each side
  useEffect(() => {
    const boundingRectObj = boundingRect as DOMRect;

    const out: IsOutOfBoundType = {};
    if (boundingRectObj) {
      out.top = boundingRectObj.top < 0;
      out.left = boundingRectObj.left < 0;
      out.bottom =
        boundingRectObj.bottom > (window.innerHeight || document.documentElement.clientHeight);
      out.right =
        boundingRectObj.right > (window.innerWidth || document.documentElement.clientWidth);
      out.any = out.top || out.left || out.bottom || out.right;
      out.all = out.top && out.left && out.bottom && out.right;
    }
    setIsOutOfBound(out);
  }, [boundingRect]);

  return { isOutOfBound, outOfBoundRef: ref };
};
